import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/sign-up-facebook.svg'


const _hoisted_1 = { class: "button__text d-none d-md-inline" }

import { FacebookAuthView } from '@/models/auth/facebook'
import { FacebookNativeAuthView } from '@/models/auth/facebook.native'


export default /*@__PURE__*/_defineComponent({
  __name: 'FacebookLoginButton',
  props: {
    view: {},
    title: {}
  },
  setup(__props: any) {

const props = __props

async function fbLoginClick(): Promise<void> {
  await props.view.start()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "button button--blue facebookSignIn shortform-sign-up__button",
    onClick: fbLoginClick
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "button__img",
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title) + " Facebook", 1),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "button__text d-md-none" }, "Facebook", -1))
  ]))
}
}

})